import { useState, useMemo } from 'react';

export default function useCheckboxes(rawList) {
  const [checkedItems, setCheckedItems] = useState([]);

  const allChecked = useMemo(
    () =>
      Array.isArray(rawList) &&
      checkedItems.length > 0 &&
      checkedItems.length === rawList.length,
    [rawList, checkedItems]
  );

  const noneChecked = useMemo(
    () =>
      Array.isArray(rawList) && rawList.length > 0 && checkedItems.length === 0,
    [rawList, checkedItems]
  );

  function toggleItem(checked, item, filterFn) {
    setCheckedItems((prevCheckedItems) =>
      checked
        ? prevCheckedItems.concat([item])
        : prevCheckedItems.filter(filterFn)
    );
  }

  function toggleAll(checked) {
    setCheckedItems(checked ? rawList : []);
  }

  function resetCheckedItems() {
    setCheckedItems([]);
  }

  return {
    checkedItems,
    allChecked,
    noneChecked,
    toggleItem,
    toggleAll,
    resetCheckedItems,
  };
}
